module.exports = __webpack_public_path__ + "static/media/BabyCourse_Mobile_3.1e8914b6.jpg";